<template>
    <v-main>
      <GovHero/>
      <GovPanel/>
      <GovSecurity/>
      <GovUses/>
      <GovCompliance/>
      <RequestDemo msg="Government communications made modern — with security and compliance built in."/>


    </v-main>
</template>
  
<script>
import GovHero from './GovHero.vue'
import GovPanel from './GovPanel.vue'
import GovSecurity from './GovSecurity.vue'
import GovUses from './GovUses.vue'
import GovCompliance from './GovCompliance.vue'
import RequestDemo from './RequestDemo.vue'


export default {
  name: 'GovPage',
  components: {
    GovHero,
    GovPanel,
    GovSecurity,
    GovUses,
    GovCompliance,
    RequestDemo


  },
}
</script>